import React, { useEffect, useState } from 'react';
import {
  Table,
  Td,
  Th,
  Tr
} from '../../quoteSummary/componets/css';

const CodeBasedPromotions = ({orderData}) => {
   const {
        redeemOfferData:{redeemOfferSelection}
    } = orderData;

  const [redeemOfferData, setRedeemOfferData] = useState(redeemOfferSelection);


  return (
    <div>
      {redeemOfferData && !!redeemOfferData.length && (
        <Table>
          <Th>Coupon Code</Th>
          <Th>Validation Code</Th>
          <Th>Discount Amount</Th>
          <Th>Duration</Th>
          {/* Add this column for edit/delete buttons */}
          {redeemOfferData.map(
            (
              { couponCode, validationCode, promotionAmount, duration },
              idx
            ) => (
              <Tr key={`${idx}`}>
                <Td>{couponCode}</Td>
                <Td>{validationCode}</Td>
                <Td>{promotionAmount}</Td>
                <Td>{duration}</Td>
                
              </Tr>
            )
          )}
          
        </Table>
      )}
     
    </div>
  );
};

export default CodeBasedPromotions;
